/** @format */

import { IconButton, SvgIcon, Tooltip } from '@mui/material';
import Settings01Icon from '@untitled-ui/icons-react/build/esm/Settings01';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useGetConfigSettingsQuery } from 'src/api/setting-api';
import { refreshKeyConfig } from 'src/config';
import { useDrawer } from 'src/hooks/use-drawer';
import { useServerError } from 'src/hooks/use-server-error';
import { setRefesh } from 'src/store/app-slice';
import { SettingsDrawer } from './booking-settings-drawer';

export const BookingSettingsButton = () => {
  const drawer = useDrawer();
  const dispatch = useDispatch();
  const { processError } = useServerError();

  const { isLoading, isSuccess, error } = useGetConfigSettingsQuery({ field: { key: true, value: true, valueType: true } });

  useEffect(() => {
    if (isLoading) {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: true
        })
      );
    } else {
      dispatch(
        setRefesh({
          [refreshKeyConfig.pageLoading]: false
        })
      );
    }
  }, [isLoading]);

  if (error) {
    processError(error);
  }

  return (
    <>
      <Tooltip title="Cài đặt">
        <IconButton onClick={drawer.handleOpen}>
          <SvgIcon>
            <Settings01Icon
              sx={{
                cursor: 'pointer'
              }}
            />
          </SvgIcon>
        </IconButton>
      </Tooltip>
      {isSuccess && <SettingsDrawer onClose={drawer.handleClose} open={drawer.open} />}
      {/* <BookingSettingsPopover anchorEl={popover.anchorRef.current} settings={settings} onClose={popover.handleClose} open={popover.open} /> */}
    </>
  );
};
